import FilterPostApiv2 from 'Client/api/filter-postv2';
import { generateVectorPosition } from 'Client/utils/vector-position';
import * as $ from 'jquery';

const PROGRAMMES_SIZE = 5;
let LOAD_TIMES_COUNT = 0;
class FilterPost extends elementorModules.frontend.handlers.Base {

    getDefaultSettings() {
        return {
            selectors: {
                filterPost: '#filter-post',
                post: '#checklist-post',
                posts: '#post-list',
                years: '#checklist-years',
                yearsInput: 'input[name="checklist-year-field"]',
                applyFilter: '.apply-filter',
                clearAllButton: '.clear-all',
                seeAllButton: '#see-all',
                postInput: 'input[name="checklist-post-field"]',
                filterModal: '.content-checklist',
                btnFilterModal: '.btn-filter-mb',
                contentChecklist: '.content-checklist',
            }
        };
    }

    getDefaultElements() {
        const selectors = this.getSettings('selectors');
        return {
            // Tạo variables DOM trong widget\
            $filterPost: this.$element.find(selectors.filterPost),
            $posts: this.$element.find(selectors.posts),
            $applyFilter: this.$element.find(selectors.applyFilter),
            $clearAllButton: this.$element.find(selectors.clearAllButton),
            $seeAllButton: this.$element.find(selectors.seeAllButton),
            $postInput: this.$element.find(selectors.postInput),
            $filterModal: this.$element.find(selectors.filterModal),
            $btnFilterModal: this.$element.find(selectors.btnFilterModal),
            $contentChecklist: this.$element.find(selectors.contentChecklist),
            $years:this.$element.find(selectors.years),
            $yearsInput:this.$element.find(selectors.yearsInput),
        };
    }

    bindEvents() {
        const THIS = this;
        this.loadPosts();
        !this.isMobile() && this.handleChangePost();
        this.handleSeeAll();
        this.handlePopupFilter();
        this.handleClearAll();
        this.handleApplyFilter();
        this.isVector();
    }

    isVector() {
        const THIS = this;
        const ELEMENT = this.elements.$filterPost[0];
        if (ELEMENT) {
            let imgs = Array.prototype.slice.call(ELEMENT.querySelectorAll('picture img'));
            imgs.forEach(element => {
                let dataPosition = element.getAttribute('data-position');
                let dataResponsive = element.getAttribute('data-responsive');
                let obj_img = JSON.parse(atob(dataPosition))
                let responsive = JSON.parse(atob(dataResponsive))
                let unit = "px"
                generateVectorPosition(obj_img, responsive, element, unit);
            });
        }
    }

    isMobile() {
        const THIS = this;
        const postsElement = this.elements.$posts;
        return postsElement && postsElement.attr('data-is-mobile') == '1';
    }
    isFixedBtnFilterModal(){
        const btnFilterModal = this.elements.$btnFilterModal;
        const posts = Array.prototype.slice.call(this.elements.$posts[0].querySelectorAll('.card-post'))
        let topLastChild = posts[posts.length - 1].offsetTop + 415;
        let offsetTop = btnFilterModal.offset().top - btnFilterModal.height();
        $(window).on('scroll', function() {
            let isScroll = $(window).scrollTop()
            if(isScroll >= offsetTop && isScroll <= topLastChild && !btnFilterModal.hasClass('active')){
                btnFilterModal.addClass('active');
            }else if((isScroll >= offsetTop && isScroll >= topLastChild )|| isScroll <= offsetTop){
                btnFilterModal.hasClass('active')? btnFilterModal.removeClass('active') : '';
            }
           
        });
    }

    clearPostCheckbox() {
        const postInput = this.elements.$postInput;
        postInput && postInput.prop('checked', false);
    }

    clearYearCheckbox() {
        const yearsInput = this.elements.$yearsInput;
        yearsInput && yearsInput.prop('checked', false);
    }
    getPostChecked() {
        const paramPost = document.getElementById('param-category');
        const postInput = this.elements.$postInput;
        let postChecked = [];
        postInput && postInput.each(function(index, post) {
            let termId = $(post).attr('value');
            let isParamPost = paramPost !== null && termId == paramPost.value;
            isParamPost && $(post).prop('checked', true) && paramPost.remove();
            $(post).is(':checked') && postChecked.push(Number(termId));
        })
        return postChecked;
    }

    getYearChecked() {
        const postInput = this.elements.$yearsInput;
        let postYearCheck = [];
        postInput && postInput.each(function(index, post) {
            let yearID = $(post).attr('year_value');
            $(post).is(':checked') && postYearCheck.push(Number(yearID));
        })
        return postYearCheck;
    }

    handleApplyFilter() {
        const THIS = this;
        const applyFilter = this.elements.$applyFilter;
        const filterModal = this.elements.$filterModal
        let html = $('html')
        applyFilter && applyFilter.on('click', function(e) {
            filterModal.removeClass('active')
            html.removeClass('overflow-hidden')
            THIS.loadPosts();
        });
    }
    handleClearAll() {
        const THIS = this;
        const clearAllButton = this.elements.$clearAllButton;
        clearAllButton && clearAllButton.on('click', function(e) {
            THIS.clearPostCheckbox();
            THIS.clearYearCheckbox();
        });
    }

    handleChangePost() {
        const THIS = this;
        const postInput = this.elements.$postInput;
        const yearInput = this.elements.$yearsInput;
        const posts = this.elements.$posts;
        let topPosts = posts.offset().top -50;
        let btnSeeAll = document.querySelector('#see-all');
        postInput && postInput.on('change', function(e) {
            if(btnSeeAll.classList.contains('actvie')){
                btnSeeAll.classList.remove('active');
                btnSeeAll.innerText = 'See all';
            }
            window.scrollTo({
                top: topPosts,
                left: 0,
                behavior: 'smooth'
              });
            THIS.loadPosts();
        });

        yearInput && yearInput.on('change', function(e) {
            window.scrollTo({
                top: topPosts,
                left: 0,
                behavior: 'smooth'
              });
            if(btnSeeAll.classList.contains('active')){
                btnSeeAll.classList.remove('active');
                btnSeeAll.innerText = 'See all';
            }
            THIS.loadPosts();
        });
    }

    setInputNoExist(post_available,year_available) {
        const postInput = $(this.elements.$postInput);
        const yearInput = $(this.elements.$yearsInput);
        // Because condition is OR so will no need disable for this one
        // postInput.each((index,item)=>{
        //     let attVal = item.getAttribute('value');
        //     let result =  post_available.findIndex(item => item[1] === Number(attVal));
        //     item.closest('.posts-item').classList.toggle('no-check', result === -1);
        // });

        // if(LOAD_TIMES_COUNT<1){
        //     yearInput.each((index,item)=>{
        //         let attVal = item.getAttribute('year_value');
        //         let result =  year_available.findIndex(item => item[1] == Number(attVal));
        //         item.closest('.years-item').classList.toggle('no-check', result === -1);
        //     });
        //     LOAD_TIMES_COUNT = LOAD_TIMES_COUNT + 1;
        // }
    }

    removeParam(key, sourceURL) {
        var rtn = sourceURL.split("?")[0],
            param,
            params_arr = [],
            queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
        if (queryString !== "") {
            params_arr = queryString.split("&");
            for (var i = params_arr.length - 1; i >= 0; i -= 1) {
                param = params_arr[i].split("=")[0];
                if (param === key) {
                    params_arr.splice(i, 1);
                }
            }
            if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
        }
        return rtn;
    }

    loadPosts(offset = 0, size = PROGRAMMES_SIZE,year) {
        const THIS = this;
        const seeAllButton = this.elements.$seeAllButton;
        const postsElement = this.elements.$posts[0];
        const postChecked = THIS.getPostChecked() || [];
        const postYearChecked = THIS.getYearChecked() || [];

        if (offset == 0) {
            seeAllButton.hide();
        }

        let req = {
            "cat": postChecked,
            "offset": offset,
            "total": size,
            "year":postYearChecked,
        }
        let filterPostApi = new FilterPostApiv2();
        filterPostApi.load(req)
            .then((rsp) => {
                if (rsp.code === 200) {
                    rsp.total && localStorage.setItem('post-count', rsp.total);
                    if(rsp.category_available && rsp.year_available){
                        let category_available = typeof rsp.category_available!=='undefined' ? Object.entries(rsp.category_available) :[];
                        let year_available = typeof rsp.year_available!=='undefined' ? Object.entries(rsp.year_available) : [];
                        THIS.setInputNoExist(category_available,year_available)
                    }
                    let html = rsp.data
                        .map(p => THIS.postItemTemplate(
                            p.title,
                            p.date,
                            p.excerpt,
                            p.permalink,
                            p.cats))
                        .join('');
                    if (offset == 0) {
                        postsElement.innerHTML = html;
                    } else {
                        postsElement.insertAdjacentHTML("beforeend", html);
                    }

                    if(offset == 0 && rsp.total > size) {
                        seeAllButton.show();
                        seeAllButton.text('See all');
                        seeAllButton.removeClass('active');
                    }

                    rsp.data.length > 0 && THIS.isFixedBtnFilterModal()
                }
            })
            .then(()=>{
                let btnSeeAll = document.querySelector('#see-all');
                btnSeeAll.addEventListener('click',()=>{
                    if(!btnSeeAll.classList.contains('active')){
                        let postList = document.querySelector('#post-list');
                        setTimeout(()=>{
                            window.scrollTo({
                                top: document.querySelector('#filter-post').clientHeight,
                                left: 0,
                                behavior: 'smooth'
                            });
                            //postList.scrollIntoView({behavior: "auto", block: "end", inline: "nearest"})
                        },500)
                    }
                })
            })
    }
    handleOnclickFilter() {
        let closePopup = $('#filter-post .close-popup')
        let btnFilter = $('.btn-filter-mb');
        let contentChecklist = $('.content-checklist')
        let html = $('html')
        btnFilter.on('click', function() {
            html.addClass('overflow-hidden')
            contentChecklist.addClass('active')
        })

        closePopup.on('click', function() {
            html.removeClass('overflow-hidden')
            contentChecklist.removeClass('active')
        })

    }

    // postItemTemplate(title, subTitle, who, description, permalink, post = []) {
    //     let postElement = [];

    //     if (post) {
    //         postElement = post.map(p => `<span>${p.name}</span>`).join('');
    //     }
    // }
    handlePopupFilter() {
        const THIS = this;
        const filterModal = this.elements.$filterModal;
        const btnFilterModal = this.elements.$btnFilterModal;
        const contentChecklist = this.elements.$contentChecklist;
        let closePopup = filterModal.find('.close-popup')
        let html = $('html')
        btnFilterModal.on('click', function() {
            html.addClass('overflow-hidden')
            contentChecklist.addClass('active')
        })
        closePopup.on('click', function() {
            html.removeClass('overflow-hidden')
            contentChecklist.removeClass('active')
        })
    }

    handleSeeAll() {
        const THIS = this;
        let seeAll = $('#filter-post #see-all');
        seeAll.on('click', function(e) {
            let text = seeAll.text()
            if (text == "See all") {
                text = 'See less';
                seeAll.addClass('active')
                THIS.loadPosts(PROGRAMMES_SIZE, localStorage.getItem('post-count'));
            } else {
                text = 'See all';
                seeAll.removeClass('active');
                THIS.loadPosts(0, PROGRAMMES_SIZE);
            }
            seeAll.text(text);
        });
    }

    postItemTemplate(title, date, excerpt, permalink, cats = []) {
        let postElement = [];
        if (cats) {
            postElement = cats.map(p => `<span>${p.name}</span>`).join('');
        }

        return `
        <div class="card-post">
            <div class="sub-title-content ecf-title-mini-box-ns ecf-title-mini-box d-lg-none mb-lg-0 mb-3">${date}</div>
            <div class="card-text-title">
                <h3 class="ecf-title-box">${title}</h3>
            </div>
            <div class="card-content">
                <div class="sub-title-content ecf-title-mini-box-ns ecf-title-mini-box">${date}</div>
                <div class="description ecf-content">${excerpt}</div>
                <div class="tag-title">
                    ${postElement}
                </div>
                <div class="url-learn-more">
                    <a href="${permalink}" class="ecf-link">
                        Learn more
                    </a>
                </div>
            </div>
        </div>
        `;
    }
}

jQuery(window).on('elementor/frontend/init', () => {
    const addHandler = ($element) => {
        elementorFrontend.elementsHandler.addHandler(FilterPost, {
            $element,
        });
    };
    // efc_form_donate ->Name widget register in php
    elementorFrontend.hooks.addAction('frontend/element_ready/ecf_filter_post.default', addHandler);
});